import { ApiRequest, deleteItem, postItem, putItem } from 'utils/ApiUtils';

class Domain {
    constructor(props) {
        this.description = props.description;
        this.domainId = props.domainId;
        this.name = props.name;
    }

    static columns = [
        { field: "description", title: "Value", type: "string" },
        { field: "domainId", title: "Domain Id", hidden: true },
        { field: "isActive", title: "Active?", type: "boolean" }
    ]

}

const buildDomainUrl = (domain) => {
    return `/Domain?domainName=${domain}&includeReserved=false&includeInactive=true`
};

const adminConfigDomains = Object.freeze({
    "LuEquipmentType": {
        label: "Equipment Type",
        domainName: "LuEquipmentType",
        url: buildDomainUrl("LuEquipmentType"),
        dbTable: "Lu_Equipment_Type"
    },
    "Contractor": {
        label: "Contractor",
        domainName: "LuContractor",
        url: buildDomainUrl("LuContractor"),
        dbTable: "Lu_Contractor"
    }
});

const projectConfigDomains = Object.freeze({
    "LuStations": {
        label: "Stations",
        domainName: "LuStation",
        url: buildDomainUrl("LuStations"),
        dbTable: "Lu_Stations"
    },
    "LuWitnessInspectionType": {
        label: "Observations",
        domainName: "LuWitnessInspectionType",
        url: buildDomainUrl("LuWitnessInspectionType"),
        dbTable: "Lu_Witness_Inspection_Type"
    },
    "LuTestType": {
        label: "Test Types",
        domainName: "LuTestType",
        url: buildDomainUrl("LuTestType"),
        dbTable: "LU_TEST_TYPE"
    },
    "LuIssueType": {
        label: "Issue Types",
        domainName: "LuIssueType",
        url: buildDomainUrl("LuIssueType"),
        dbTable: "LU_ISSUE_TYPE"
    }
    ,
    "LuMaterialName": {
        label: "Material Names",
        domainName: "LuMaterialName",
        url: buildDomainUrl("LuMaterialName"),
        dbTable: "LU_MATERIAL_NAME"
    }
});


const getDomain = async (domain, projectId) => {
    let reqUrl = domain.url;
    if (projectId) {
        reqUrl += `&projectId=${projectId.toUpperCase()}`;
    }
    console.log(projectId)
    const resp = await ApiRequest(reqUrl, '');
    resp.data && resp.data.sort((a, b) => a.description.localeCompare(b.description));
    return {
        ...resp,
        domain: domain
    }
};

/*
const getDomains = async (apiEndpoint, domainClass, ODataProps) => {
  let { page, per_page, orderByInfo, orderByDirection, search, filters } = ODataProps;
  const { skip, count, top, expand, orderBy, mappedFilter } = ODataUtil.UtilityBuilderNestedv3(
    per_page, page, domainClass.expand, orderByInfo, orderByDirection, filters
  );
  
  const filter = {};

  const allFilters = mappedFilter.reduce((a, b) => ({...a, ...b}), filter);
  const params = buildQuery({ count, top, skip, orderBy, expand, filter: allFilters });
  const data = await ApiRequest(apiEndpoint, params);
  return domainClass.convertToTableRows(data);
}
*/

const updateDomain = async (domainId, domainValue, isActive, projectId = undefined) => {
    const endpoint = "/Domain/Update";

    let urlParams = `?domainId=${domainId}&isActive=${isActive}`
    if (projectId) { urlParams += `&projectId=${projectId}` };

    const data = {
        DomainValue: domainValue
    }

    const result = await putItem(endpoint, urlParams, data);

    return result
}

const deleteDomain = async (domainId) => {
    const endpoint = "/Domain/Delete";
    const urlParams = `?domainId=${domainId}`;
    const result = await deleteItem(endpoint, urlParams);
    return result;
}

const addDomain = async (tableName, domainValue, projectId = undefined) => {
    const endpoint = "/Domain/Add";
    let urlParams = `?tableName=${tableName}`;
    if (projectId) {
        urlParams += `&projectId=${projectId}`
    };

    const data = {
        DomainValue: domainValue
    }

    const result = await postItem(endpoint, urlParams, data);
    return result;
}

export { getDomain, Domain, adminConfigDomains, projectConfigDomains, buildDomainUrl, deleteDomain, addDomain, updateDomain };